let driverModule: any = null;

export async function loadDriver() {
    if (driverModule) return driverModule;

    try {
        const mod = await import('driver.js');
        await import('driver.js/dist/driver.css');
        await import('./vacationTour.css');
        driverModule = mod;
        return mod;
    } catch (error) {
        console.error('Failed to load driver.js:', error);
        return null;
    }
}
